const CATEGORY_PAGE_BRAND_ID_DELIMITER = '-';
const CATEGORY_PAGE_LINK_REGEX = /(.+)-c-([0-9]+(\?|$|#))/;
const CATEGORY_PAGE_ROUTE_PATH_REGEX = ':categoryUrlKeyword([^/]*)-c-:categoryId([0-9]+)';

const CATEGORY_PAGE_LINK_WITH_BRAND_REGEX = /\/(.+)\/(.+)-c-[0-9]+(\?|$|#)/;

const CATEGORY_PAGE_LIST_LAYOUT_TYPE = {
  DOUBLE_COLUMN: 'DOUBLE_COLUMN',
};

const CATEGORY_SEARCH_KEYWORD_TITLE = {
  MOST_SEARCHED_KEYWORDS: 'En Çok Aranan Kelimeler',
  SUB_CATEGORIES: 'Alt Kategoriler',
  POPULAR_KEYWORDS:'Popüler Aramalar'
}

const CATEGORY_PAGE_LIST_COOKIE_TYPE = {
  GRID: 'grid',
};

const CATEGORY_PAGE_LIST_COOKIE = 'SearchListingSort.listingType';
const CATEGORY_PRODUCTS_COUNT_FOR_ONE_PAGE = 24;

const CATEGORY_PAGE_DOUBLE_COLUMN_IMG_SIZE = '300-443';

const CATEGORY_PAGE_ANDROID_TARGET_BRANDS = ['Vivo', 'Realme', 'Oneplus', 'Oppo', 'HONOR', 'POCO', 'Huawei', 'Xiaomi', 'Samsung'];

export {
  CATEGORY_PAGE_BRAND_ID_DELIMITER,
  CATEGORY_PAGE_LINK_REGEX,
  CATEGORY_PAGE_LINK_WITH_BRAND_REGEX,
  CATEGORY_PAGE_ROUTE_PATH_REGEX,
  CATEGORY_PAGE_LIST_LAYOUT_TYPE,
  CATEGORY_PAGE_LIST_COOKIE_TYPE,
  CATEGORY_PAGE_LIST_COOKIE,
  CATEGORY_PRODUCTS_COUNT_FOR_ONE_PAGE,
  CATEGORY_PAGE_DOUBLE_COLUMN_IMG_SIZE,
  CATEGORY_SEARCH_KEYWORD_TITLE,
  CATEGORY_PAGE_ANDROID_TARGET_BRANDS,
};
